// This component has been added ad-hoc by coaching-fe team: https://private.hubteam.com/janus/groups/hs-coaching-fe
// For any questions/concerns, please use Slack channel: #coaching-fe

import http from 'hub-http/clients/apiClient';
import { useEffect, useState } from 'react';
export const useTranscriptData = (hasTranscriptionFeature = true) => {
  const [loading, setLoading] = useState(false);
  const [hasTranscriptSettingEnabled, setHasTranscriptSettingEnabled] = useState();
  const [error, setError] = useState();
  useEffect(() => {
    if (hasTranscriptionFeature) {
      setLoading(true);
      http.get('/transcript/v1/setting/transcript').then(response => {
        setHasTranscriptSettingEnabled(response);
        setLoading(false);
      }).catch(ex => {
        setError(ex);
        setLoading(false);
      });
    }
  }, [hasTranscriptionFeature]);
  return {
    loading,
    hasTranscriptSettingEnabled,
    error
  };
};